<div class="filters-mobile-container" *ngIf="filters$ | async; let filters">
  <ng-container *ngIf="filters.length > 1">
    <div class="filters-mobile-container__title">
      <span>
        Solo quiero ver {{ (isHotel$ | async) ? 'habitaciones' : 'alojamientos' }} con:
      </span>
    </div>

    <div class="filters-mobile-container__chips-wrapper">
      <div
        *ngFor="let filter of filters"
        class="filters-mobile-container__chips-wrapper__chip"
        [class.filters-mobile-container__chips-wrapper__chip--active]="filter.active"
        [class.filters-mobile-container__chips-wrapper__chip--disabled]="filter.disabled"
        (click)="onFilterClick(filter)"
      >
        {{ filter.label }}
        <mb-icon [icon]="filter.active ? 'x-close' : 'add'"></mb-icon>
      </div>
    </div>

    <div
      *ngIf="someFilterActive | async"
      class="filters-mobile-container__show-all-rooms"
    >
      <p (click)="resetFilters()">
        Ver {{ (isHotel$ | async) ? 'todas las habitaciones' : 'todos los alojamientos' }}
      </p>
    </div>
  </ng-container>
</div>
